import * as React from "react";

export default class KnowledgeBaseHeader extends React.PureComponent {
    public render() {
        return <div className="knowledge-base-main__header">NLP</div>
    }
}
